import { render, staticRenderFns } from "./C01MovePOToWarehouse.vue?vue&type=template&id=687f48c8&"
import script from "./C01MovePOToWarehouse.vue?vue&type=script&lang=js&"
export * from "./C01MovePOToWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports